"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.save = exports.remove = exports.purge = exports.load = exports.SessionStorage = exports.LocalStorage = void 0;
var _cookie = _interopRequireDefault(require("cookie"));
var _cookies = require("./cookies");
exports.analytics = _cookies.analytics;
exports.marketing = _cookies.marketing;
exports.Cookie = _cookies.Cookie;
exports.necessary = _cookies.necessary;
exports.LocalStorage = _cookies.LocalStorage;
exports.SessionStorage = _cookies.SessionStorage;
var Header = /*#__PURE__*/function (Header) {
  Header["SET_COOKIE"] = "Set-Cookie";
  return Header;
}(Header || {});
const saveCookie = _ref => {
  var _options$path;
  let {
    key,
    value,
    options,
    res
  } = _ref;
  if (res == null || res.headersSent) {
    return;
  }
  const opts = {
    ...options,
    path: (_options$path = options.path) !== null && _options$path !== void 0 ? _options$path : "/",
    // To stay compatible with JSCookie's lenient type of 'expires'
    // https://github.com/js-cookie/js-cookie/blob/master/src/api.mjs#L12-L14
    expires: typeof options.expires === "number" ? new Date(Date.now() + options.expires * 864e5) : options.expires
  };
  const curr = res.getHeader(Header.SET_COOKIE);
  if (curr == null) {
    res.setHeader(Header.SET_COOKIE, _cookie.default.serialize(key, value, opts));
    return;
  }
  if (Array.isArray(curr)) {
    res.setHeader(Header.SET_COOKIE, [...curr, _cookie.default.serialize(key, value, opts)]);
    return;
  }
  res.setHeader(Header.SET_COOKIE, [String(curr), _cookie.default.serialize(key, value, opts)]);
};
const load = _ref2 => {
  var _req$headers$cookie, _ref3;
  let {
    key,
    req
  } = _ref2;
  const cookies = _cookie.default.parse((_req$headers$cookie = req === null || req === void 0 ? void 0 : req.headers.cookie) !== null && _req$headers$cookie !== void 0 ? _req$headers$cookie : "");
  return (_ref3 = cookies[key]) !== null && _ref3 !== void 0 ? _ref3 : null;
};
exports.load = load;
const save = _ref4 => {
  let {
    key,
    value,
    options,
    req,
    res
  } = _ref4;
  const name = (0, _cookies.getCanonicalName)(key);
  if (name == null) {
    return;
  }
  const opts = (0, _cookies.getOptions)(name, options);
  if (name in _cookies.necessary) {
    saveCookie({
      key,
      value,
      options: opts,
      res
    });
    return;
  }
  const rawSettings = load({
    key: _cookies.Cookie.SETTINGS,
    req
  });
  if (rawSettings === null) {
    return;
  }
  const settings = JSON.parse(rawSettings);
  if ((0, _cookies.shouldSetCookie)(name, settings)) {
    saveCookie({
      key,
      value,
      options: opts,
      res
    });
  }
};
exports.save = save;
const remove = _ref5 => {
  let {
    key,
    options,
    res
  } = _ref5;
  saveCookie({
    key,
    value: "****",
    options: {
      secure: true,
      ...options,
      expires: new Date(Date.now() - 864e5)
    },
    res
  });
};
exports.remove = remove;
const purge = _ref6 => {
  var _req$headers$cookie2;
  let {
    settings,
    req,
    res
  } = _ref6;
  const cookies = Object.keys(_cookie.default.parse((_req$headers$cookie2 = req === null || req === void 0 ? void 0 : req.headers.cookie) !== null && _req$headers$cookie2 !== void 0 ? _req$headers$cookie2 : ""));
  cookies.forEach(key => {
    const name = (0, _cookies.getCanonicalName)(key);
    if (name == null) {
      // When full list of cookies will be in code, uncomment this to only
      // allow known cookies to exist:
      // // Removes unknown cookies
      // remove({ key: key as Cookie, res });
      return;
    }
    if (!settings.analytics && name in _cookies.analytics) {
      remove({
        key,
        res
      });
      return;
    }
    if (!settings.marketing && name in _cookies.marketing) {
      remove({
        key,
        res
      });
    }
  });
};
exports.purge = purge;